import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { bindActionCreators } from 'redux';
import EditBackground from 'profile/components/edit_background';
import partial from 'lodash/partial';
import { toggleBackgroundSelector } from 'profile/ducks/view';
import { PROFILE_FORM } from 'profile/constants';

export function mapStateToProps(state) {
  const selector = formValueSelector(PROFILE_FORM);
  const profileBg = selector(state, 'profile_bg');
  const { showBackgroundSelector } = state.profile.view;
  return { profileBg, showBackgroundSelector };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleSelect: toggleBackgroundSelector,
    updateBackground: partial(change, PROFILE_FORM, 'profile_bg'),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBackground);



// WEBPACK FOOTER //
// ./profile/containers/edit_background.js